(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fct-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-announcements')) {
    customElements.define('fct-announcements', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-message]'));
        this.current = 0;
        this.paused = this.dataset.autoplay !== 'true';
        this.hovered = false;
        this.focused = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.messages = this.querySelector('.fct-announcements__messages');
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.slides.length) this.show(0, false);
        if (this.slides.length < 2) return;
        const options = { signal: this.controller.signal };
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.refresh();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.refresh(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.refresh(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.refresh(); }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.focused = this.contains(document.activeElement);
            this.refresh();
          });
        }, options);
        document.addEventListener('visibilitychange', () => this.refresh(), options);
        this.motion.addEventListener('change', () => this.refresh(), options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.paused = true;
          this.show(index, true);
          this.refresh();
        }, options);
        this.refresh();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
      }
      show(index, manual) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.messages.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.current; });
      }
      move(direction) {
        this.show(this.current + direction, true);
        this.refresh();
      }
      refresh() {
        clearInterval(this.timer);
        this.pauseButton.hidden = this.motion.matches;
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('[data-pause-icon]').hidden = this.paused;
        this.pauseButton.querySelector('[data-play-icon]').hidden = !this.paused;
        if (this.paused || this.hovered || this.focused || this.motion.matches || document.hidden) return;
        this.messages.setAttribute('aria-live', 'off');
        this.timer = setInterval(() => this.show(this.current + 1, false), Math.max(3000, Number(this.dataset.interval) || 3000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-campaign-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialize = (root) => {
      root.querySelectorAll('[data-fct-campaign-video]').forEach((container) => {
        if (container.dataset.fctVideoReady) return;
        container.dataset.fctVideoReady = 'true';
        const video = container.querySelector('video');
        if (!video) return;
        let visible = true;
        const update = () => {
          if (motion.matches || !visible || document.hidden) {
            video.pause();
          } else {
            video.play().catch(() => {});
          }
        };
        video.muted = true;
        video.addEventListener('error', () => { video.style.visibility = 'hidden'; });
        if (motion.matches) {
          video.removeAttribute('autoplay');
          video.pause();
        }
        const observer = new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.05 });
        observer.observe(container);
        motion.addEventListener('change', update);
        document.addEventListener('visibilitychange', update);
        const unload = (event) => {
          if (!event.target.contains(container)) return;
          observer.disconnect();
          motion.removeEventListener('change', update);
          document.removeEventListener('visibilitychange', update);
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-collections')) {
    customElements.define('fct-collections', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.track = this.querySelector('.fct-collections__track');
        this.controls = this.querySelector('.fct-collections__controls');
        this.previous = this.querySelector('.fct-collections__previous');
        this.next = this.querySelector('.fct-collections__next');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.observer = null;
      }
      move(direction) {
        const card = this.track.querySelector('.fct-collections__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-header')) {
    customElements.define('fct-header', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('data-enhanced', '');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.queueCartCount = () => {
          clearTimeout(this.cartCountTimer);
          this.cartCountRequest?.abort();
          this.cartCountTimer = setTimeout(() => this.refreshCartCount(), 50);
        };
        ['cart:updated', 'theme:cart:add', 'fct:picker:added'].forEach(eventName => {
          document.addEventListener(eventName, this.queueCartCount, options);
        });
        window.addEventListener('mu_cart_discounts_updated', this.queueCartCount, options);
        window.addEventListener('pageshow', this.queueCartCount, options);
        window.addEventListener('focus', this.queueCartCount, options);
        if (window.PerformanceObserver?.supportedEntryTypes?.includes('resource')) {
          this.cartObserver = new PerformanceObserver(list => {
            const changed = list.getEntries().some(entry => {
              const url = new URL(entry.name, location.origin);
              return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
            });
            if (changed) this.queueCartCount();
          });
          this.cartObserver.observe({ type: 'resource' });
        }
        this.menuToggle = this.querySelector('.fct-header__menu-toggle');
        this.nav = this.querySelector('.fct-header__nav');
        this.panels = [...this.querySelectorAll('.fct-header__category')];
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.menuToggle.hidden = false;
        this.updateCompact = () => {
          this.frame = null;
          this.toggleAttribute('data-compact', window.scrollY > this.compactThreshold);
        };
        this.measureHeader = () => {
          this.removeAttribute('data-compact');
          const utilityHeight = this.querySelector('.fct-header__utility').getBoundingClientRect().height;
          const navHeight = this.desktop.matches ? this.nav.getBoundingClientRect().height : 0;
          const expandedHeight = utilityHeight + navHeight;
          const compactHeight = this.desktop.matches ? 64 : 62;
          this.style.setProperty('--fct-expanded-height', `${expandedHeight}px`);
          this.compactThreshold = this.getBoundingClientRect().top + window.scrollY + expandedHeight - compactHeight;
          this.updateCompact();
        };
        this.queueCompact = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(this.updateCompact);
        };
        window.addEventListener('scroll', this.queueCompact, { ...options, passive: true });
        window.addEventListener('resize', this.measureHeader, options);
        this.querySelector('.fct-header__logo')?.addEventListener('load', this.measureHeader, options);
        document.fonts?.ready.then(() => { if (this.isConnected) this.measureHeader(); });
        this.measureHeader();
        this.menuToggle.addEventListener('click', () => {
          const open = this.menuToggle.getAttribute('aria-expanded') !== 'true';
          this.menuToggle.setAttribute('aria-expanded', String(open));
          this.nav.classList.toggle('fct-header__nav--open', open);
          if (!open) this.panels.forEach(panel => { panel.open = false; });
        }, options);
        this.panels.forEach(panel => {
          const grids = [...panel.querySelectorAll('[data-fct-spotlight-grid]')];
          const triggers = [...panel.querySelectorAll('[data-fct-spotlight-target]')];
          const heading = panel.querySelector('[data-fct-spotlight-heading]');
          const showSpotlight = trigger => {
            const active = grids.find(grid => grid.id === trigger.dataset.fctSpotlightTarget);
            if (!active) return;
            grids.forEach(grid => { grid.hidden = grid !== active; });
            triggers.forEach(link => link.toggleAttribute('data-fct-spotlight-active', link === trigger));
            if (heading) heading.textContent = active.dataset.label ? `${heading.dataset.defaultLabel} — ${active.dataset.label}` : heading.dataset.defaultLabel;
          };
          triggers.forEach(trigger => {
            trigger.addEventListener('pointerenter', event => {
              if (this.desktop.matches && event.pointerType !== 'touch') showSpotlight(trigger);
            }, options);
            trigger.addEventListener('focus', () => showSpotlight(trigger), options);
          });
          panel.parentElement.addEventListener('pointerenter', event => {
            if (!this.desktop.matches || event.pointerType === 'touch') return;
            if (!panel.open && triggers[0]) showSpotlight(triggers[0]);
            this.panels.forEach(other => { other.open = other === panel; });
          }, options);
          panel.parentElement.addEventListener('pointerleave', () => {
            if (this.desktop.matches && !panel.contains(document.activeElement)) panel.open = false;
          }, options);
          panel.addEventListener('toggle', () => {
            panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
            if (panel.open) this.panels.forEach(other => { if (other !== panel) other.open = false; });
          }, options);
          panel.addEventListener('focusout', event => {
            if (this.desktop.matches && !panel.contains(event.relatedTarget)) panel.open = false;
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const activePanel = this.panels.find(panel => panel.open && panel.contains(document.activeElement));
          this.panels.forEach(panel => { panel.open = false; });
          if (activePanel) activePanel.querySelector('summary').focus();
          if (!this.desktop.matches) {
            this.nav.classList.remove('fct-header__nav--open');
            this.menuToggle.setAttribute('aria-expanded', 'false');
            this.menuToggle.focus();
          }
        }, options);
        document.addEventListener('click', event => {
          if (this.contains(event.target)) return;
          this.panels.forEach(panel => { panel.open = false; });
          this.nav.classList.remove('fct-header__nav--open');
          this.menuToggle.setAttribute('aria-expanded', 'false');
        }, options);
        this.desktop.addEventListener('change', () => {
          this.panels.forEach(panel => { panel.open = false; });
          this.nav.classList.remove('fct-header__nav--open');
          this.menuToggle.setAttribute('aria-expanded', 'false');
          this.measureHeader();
        }, options);
      }
      async refreshCartCount() {
        const request = new AbortController();
        this.cartCountRequest = request;
        const root = window.Shopify?.routes?.root || window.theme?.routes?.root || '/';
        try {
          const response = await fetch(`${root.replace(/\/?$/, '/')}cart.js`, {
            credentials: 'same-origin', cache: 'no-store', signal: request.signal
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (!this.isConnected || request.signal.aborted || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
          const badge = this.querySelector('[data-fct-cart-count]');
          if (badge && badge.textContent !== String(cart.item_count)) badge.textContent = String(cart.item_count);
        } catch {}
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.cartObserver?.disconnect();
        this.cartCountRequest?.abort();
        clearTimeout(this.cartCountTimer);
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-landing-content"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fct-countdown')) {
  customElements.define('fct-countdown', class extends HTMLElement {
    connectedCallback() {
      const duration = Math.max(1, Number(this.dataset.duration) || 1) * 1000;
      const fixed = Date.parse(this.dataset.end);
      this.end = fixed;
      if (!Number.isFinite(fixed)) {
        try { this.end = Number(localStorage.getItem('fct-countdown:' + this.dataset.key)); } catch {}
        if (!this.end || (this.end <= Date.now() && this.hasAttribute('data-loop'))) this.end = Date.now() + duration;
        try { localStorage.setItem('fct-countdown:' + this.dataset.key, String(this.end)); } catch {}
      }
      const render = () => {
        if (this.end <= Date.now() && !Number.isFinite(fixed) && this.hasAttribute('data-loop')) {
          this.end = Date.now() + duration;
          try { localStorage.setItem('fct-countdown:' + this.dataset.key, String(this.end)); } catch {}
        }
        const seconds = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        this.querySelector('output').textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
      };
      render();
      this.interval = setInterval(render, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-marquee')) {
    customElements.define('fct-marquee', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.fct-marquee__pause');
        if (!button || this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-product-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-product-row')) {
    customElements.define('fct-product-row', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.track = this.querySelector('[data-fct-track]');
        if (!this.track) return;
        this.previous = this.querySelector('[data-fct-prev]');
        this.next = this.querySelector('[data-fct-next]');
        this.setAttribute('data-ready', '');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
        this.querySelectorAll('[data-fct-choices]').forEach((choices) => {
          const summary = choices.querySelector('summary');
          const panel = choices.querySelector('.fct-product-card__variant-list');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.openChoices === choices) {
              this.closeVariantMenu();
              return;
            }
            document.querySelectorAll('fct-product-row').forEach((row) => row.closeVariantMenu?.());
            this.openChoices = choices;
            choices.open = true;
            summary.setAttribute('aria-expanded', 'true');
            this.positionVariantMenu();
            if (typeof panel.showPopover === 'function') panel.showPopover();
            else panel.setAttribute('data-fct-overlay-open', '');
          }, { signal });
          panel.addEventListener('toggle', (event) => {
            if (event.newState === 'closed' && this.openChoices === choices) this.closeVariantMenu();
          }, { signal });
        });
        document.addEventListener('pointerdown', (event) => {
          if (this.openChoices && !this.openChoices.contains(event.target)) this.closeVariantMenu();
        }, { capture: true, signal });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.openChoices) return;
          this.closeVariantMenu(true);
        }, { signal });
        document.addEventListener('scroll', (event) => {
          if (this.openChoices && !this.openChoices.querySelector('.fct-product-card__variant-list').contains(event.target)) this.closeVariantMenu();
        }, { capture: true, passive: true, signal });
        window.addEventListener('resize', () => this.closeVariantMenu(), { passive: true, signal });
        const selectVariant = (choice) => {
          if (!choice || choice.disabled || !choice.dataset.variantId) return;
          const card = choice.closest('[data-fct-card]');
          const variantInput = choice.form?.querySelector('[data-fct-variant-id]');
          if (!card || !variantInput) return;
          variantInput.value = choice.dataset.variantId;
          card.querySelectorAll('[data-fct-variant-choice]').forEach((option) => {
            option.dataset.selected = String(option === choice);
          });
          card.querySelector('[data-fct-price]').textContent = choice.dataset.price;
          const compare = card.querySelector('[data-fct-compare]');
          compare.textContent = choice.dataset.compare;
          compare.hidden = choice.dataset.onSale !== 'true';
        };
        this.addEventListener('pointerdown', (event) => {
          selectVariant(event.target.closest('[data-fct-variant-choice]'));
        }, { capture: true, signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') selectVariant(event.target.closest('[data-fct-variant-choice]'));
        }, { capture: true, signal });
        this.addEventListener('click', (event) => {
          selectVariant(event.target.closest('[data-fct-variant-choice]'));
        }, { capture: true, signal });
        this.addEventListener('submit', (event) => {
          if (event.submitter?.matches('[data-fct-variant-choice]')) {
            selectVariant(event.submitter);
            this.closeVariantMenu();
          }
        }, { capture: true, signal });
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, summary, details, form')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
        }, { signal });
        window.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const delta = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(delta) < 6) return;
          if (!this.drag.moved) {
            this.drag.moved = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = this.drag.scroll - delta;
        }, { signal, passive: false });
        const finishDrag = (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const moved = this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (moved) {
            this.suppressDragClick = true;
            clearTimeout(this.dragClickTimer);
            this.dragClickTimer = setTimeout(() => { this.suppressDragClick = false; }, 0);
          }
          this.updateArrows();
        };
        window.addEventListener('pointerup', finishDrag, { signal });
        window.addEventListener('pointercancel', finishDrag, { signal });
        this.track.addEventListener('lostpointercapture', finishDrag, { signal });
        this.track.addEventListener('click', (event) => {
          if (!this.suppressDragClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { capture: true, signal });
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.updateArrows();
      }
      disconnectedCallback() {
        this.closeVariantMenu();
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.dragClickTimer);
        if (this.drag && this.track?.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.drag = null;
        this.track?.classList.remove('is-dragging');
      }
      positionVariantMenu() {
        if (!this.openChoices) return;
        const summary = this.openChoices.querySelector('summary');
        const panel = this.openChoices.querySelector('.fct-product-card__variant-list');
        const bounds = summary.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const width = Math.min(bounds.width, window.innerWidth - 16);
        const left = Math.max(8, Math.min(bounds.left, window.innerWidth - width - 8));
        const below = viewportHeight - bounds.bottom - 12;
        const above = bounds.top - 12;
        panel.style.width = `${width}px`;
        panel.style.left = `${left}px`;
        panel.style.maxHeight = `${Math.max(46, below >= 92 || below >= above ? below : above)}px`;
        if (below >= 92 || below >= above) {
          panel.style.top = `${bounds.bottom + 4}px`;
          panel.style.bottom = 'auto';
        } else {
          panel.style.top = 'auto';
          panel.style.bottom = `${viewportHeight - bounds.top + 4}px`;
        }
      }
      closeVariantMenu(restoreFocus = false) {
        const choices = this.openChoices;
        if (!choices) return;
        this.openChoices = null;
        const summary = choices.querySelector('summary');
        const panel = choices.querySelector('.fct-product-card__variant-list');
        if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) panel.hidePopover();
        panel.removeAttribute('data-fct-overlay-open');
        choices.open = false;
        summary.setAttribute('aria-expanded', 'false');
        if (restoreFocus) summary.focus({ preventScroll: true });
      }
      move(direction) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: (this.track.clientWidth + gap - 4) * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateArrows() {
        const items = this.track.children;
        if (!items.length) return;
        const image = this.track.querySelector('.fct-product-card__image');
        if (image) this.style.setProperty('--fct-image-center', `${image.offsetTop + image.offsetHeight / 2}px`);
        const bounds = this.track.getBoundingClientRect();
        const first = items[0].getBoundingClientRect();
        const last = items[items.length - 1].getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.previous.disabled = rtl ? first.right <= bounds.right + 3 : first.left >= bounds.left - 3;
        this.next.disabled = rtl ? last.left >= bounds.left - 3 : last.right <= bounds.right + 3;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fct-social-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fct-social-videos')) {
    customElements.define('fct-social-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.fct-social__track');
        this.previous = this.querySelector('[data-social-prev]');
        this.next = this.querySelector('[data-social-next]');
        this.media = [...this.querySelectorAll('.fct-social__media')].filter((media) => media.querySelector('video,iframe'));
        this.playerTimers = new Map();
        const clearPlayerTimer = (player) => {
          clearTimeout(this.playerTimers.get(player));
          this.playerTimers.delete(player);
          player.closest('.fct-social__media').querySelector('[data-social-play]').removeAttribute('aria-busy');
        };
        const send = (player, type) => {
          if (type === 'play') player.dataset.pendingPlay = 'true';
          if (type === 'pause') { delete player.dataset.pendingPlay; clearPlayerTimer(player); }
          player.contentWindow?.postMessage({ type, 'x-tiktok-player': true }, 'https://www.tiktok.com');
        };
        const setPlaying = (media, playing) => {
          media.classList.toggle('is-playing', playing);
          const toggle = media.querySelector('[data-social-play]');
          toggle.setAttribute('aria-pressed', String(playing));
          toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
        };
        const setMuted = (media, muted) => {
          const sound = media.querySelector('[data-social-sound]');
          sound.setAttribute('aria-pressed', String(muted));
          sound.setAttribute('aria-label', muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
        };
        const exposeNativeControls = (media) => {
          const player = media.querySelector('iframe');
          if (!player || player.dataset.nativeControls === 'true') return;
          clearPlayerTimer(player);
          delete player.dataset.pendingPlay;
          player.dataset.nativeControls = 'true';
          media.classList.remove('is-enhanced', 'is-playing');
          media.querySelector('[data-social-play]').hidden = true;
          media.querySelector('[data-social-sound]').hidden = true;
          const url = new URL(player.src);
          url.searchParams.set('controls', '1');
          url.searchParams.set('play_button', '1');
          url.searchParams.set('volume_control', '1');
          player.src = url.toString();
          player.focus();
        };
        const pause = (media) => {
          const video = media.querySelector('video');
          if (video) video.pause();
          else send(media.querySelector('iframe'), 'pause');
          setPlaying(media, false);
        };
        const pauseOthers = (current) => this.media.forEach((media) => { if (media !== current) pause(media); });
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('.fct-social__arrows').hidden = false;
        const update = () => {
          const firstMedia = this.querySelector('.fct-social__media');
          if (firstMedia) this.style.setProperty('--fct-social-media-height', `${firstMedia.getBoundingClientRect().height}px`);
          const overflow = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = this.track.scrollLeft < 2;
          this.next.disabled = overflow <= 2 || this.track.scrollLeft >= overflow - 2;
        };
        const scroll = (direction) => this.track.scrollBy({ left: direction * this.track.clientWidth * .8, behavior: reducedMotion ? 'instant' : 'smooth' });
        this.previous.addEventListener('click', () => scroll(-1), { signal });
        this.next.addEventListener('click', () => scroll(1), { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          scroll(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        this.videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) pause(entry.target);
        }), { threshold: .1 });
        this.media.forEach((media) => {
          const video = media.querySelector('video');
          const player = media.querySelector('iframe');
          const toggle = media.querySelector('[data-social-play]');
          const sound = media.querySelector('[data-social-sound]');
          media.classList.add('is-enhanced');
          toggle.hidden = false;
          sound.hidden = false;
          if (video) video.controls = false;
          toggle.addEventListener('click', () => {
            if (media.classList.contains('is-playing')) { pause(media); return; }
            pauseOthers(media);
            if (video) video.play().catch(() => setPlaying(media, false));
            else {
              send(player, 'play');
              toggle.setAttribute('aria-busy', 'true');
              if (!this.playerTimers.has(player)) this.playerTimers.set(player, setTimeout(() => exposeNativeControls(media), 4000));
            }
          }, { signal });
          sound.addEventListener('click', () => {
            const muted = sound.getAttribute('aria-pressed') !== 'true';
            if (video) video.muted = muted;
            else send(player, muted ? 'mute' : 'unMute');
            setMuted(media, muted);
          }, { signal });
          if (video) {
            video.addEventListener('play', () => { pauseOthers(media); setPlaying(media, true); }, { signal });
            video.addEventListener('pause', () => setPlaying(media, false), { signal });
            video.addEventListener('volumechange', () => setMuted(media, video.muted), { signal });
            video.addEventListener('ended', () => setPlaying(media, false), { signal });
          }
          this.videoObserver.observe(media);
        });
        window.addEventListener('message', (event) => {
          if (event.origin !== 'https://www.tiktok.com' || !event.data || event.data['x-tiktok-player'] !== true) return;
          const media = this.media.find((item) => item.querySelector('iframe')?.contentWindow === event.source);
          if (!media) return;
          if (event.data.type === 'onPlayerReady' && media.querySelector('iframe').dataset.pendingPlay === 'true') send(media.querySelector('iframe'), 'play');
          if (event.data.type === 'onStateChange') {
            const playing = event.data.value === 1;
            if (playing) {
              pauseOthers(media);
              const player = media.querySelector('iframe');
              clearPlayerTimer(player);
              delete player.dataset.pendingPlay;
            }
            setPlaying(media, playing);
          }
          if (event.data.type === 'onMute') setMuted(media, event.data.value === true);
          if (['onPlayerError', 'onError'].includes(event.data.type)) exposeNativeControls(media);
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.media.forEach(pause); }, { signal });
        this.pauseMedia = pause;
        update();
      }
      disconnectedCallback() {
        this.media?.forEach((media) => this.pauseMedia?.(media));
        this.playerTimers?.forEach((timer) => clearTimeout(timer));
        this.playerTimers?.clear();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.videoObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
